export interface IApiLpAdapterSetting {
  key?: string;
  value?: string;
}

export enum ApiLpConnectionStatus {
  Backup = 'BACKUP',
  Error = 'ERROR',
  Offline = 'OFFLINE',
  Online = 'ONLINE',
}

// POST/PUT connection settings. host/port/login/password are optional since LB-5154:
// not supported for adapter = UNIVERSAL_FIX (CP generates the inbound session itself).
export interface IApiLpConnectionBase {
  adapterSettings: IApiLpAdapterSetting[];
  host?: string;
  port?: number;
  login?: string;
  password?: string;
}

export interface IApiLpConnectionState {
  error?: string;
  status: ApiLpConnectionStatus;
}

// GET connection: host/port are always present (generated on the fly for UNIVERSAL_FIX),
// login/password are omitted for inbound LPs.
export interface IApiLpConnection extends IApiLpConnectionState {
  host: string;
  port: number;
  login?: string;
  password?: string;
  adapter: {
    name: string;
    settings: IApiLpAdapterSetting[];
  };
}
